import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import Carousel from './Carousel'
import Icon from './Icon'
import Button from './Button'

function SnipsterSliderItem ({ imageUrl, title, subtitle, content }) {
  return (
    <div
      style={{ height: 'auto' }}
      className='snipsters-carousel-item center flex flex-column justify-between'
    >
      <div className='snipsters-carousel-item__body bg-white overflow-hidden'>
        {imageUrl && (
          <img className='snipsters-carousel-item__image' src={imageUrl} />
        )}
        <div className='snipsters-carousel-item__text px1 py2'>
          <div className='snipsters-carousel-item__title h4 bold'>{title}</div>
          <div className='snipsters-carousel-item__subtitle h5 relative mb2'>
            {subtitle}
          </div>
          <div
            className='snipsters-carousel-item__content text-para-color'
            dangerouslySetInnerHTML={{ __html: content || '' }}
          />
        </div>
      </div>
    </div>
  )
}

class SnipstersCarousel extends Component {
  constructor () {
    super()
    this.state = { hasMounted: false }
  }
  componentDidMount () {
    // NOTE: normally a bad idea to setState in componentDidMount,
    // as it causes extra render - but that is _exactly_ what we need here.
    // We have to force this re-render here client side _after_ the initial
    // reactDOM.hydrate, because this method does not make up for differences between
    // what we return on the server and what we need on the client
    // (which is viewport size dependant)
    this.setState({ hasMounted: true })
  }
  render () {
    const { slides, greaterThanSm } = this.props
    const { hasMounted } = this.state
    if (!hasMounted) {
      // we don’t know how many items we can show on the server..
      return <div>{slides && <SnipstersCarousel {...slides[0]} />}</div>
    }
    return (
      <Carousel
        extraClass='snipsters-carousel'
        sliderOptions={{
          slidesToShow: greaterThanSm ? 3 : 1,
          initialSlide: greaterThanSm ? 2 : 0,
          dots: !greaterThanSm,
          arrows: greaterThanSm,
          autoplay: false,

          // need extra divs because react-slick overrides the classname on the element passed in
          prevArrow: (
            <div>
              <Button className='button button--secondary'>
                <Icon icon='carousel-arrow-left' />
              </Button>
            </div>
          ),
          nextArrow: (
            <div>
              <Button className='button button--secondary'>
                <Icon icon='carousel-arrow-right' />
              </Button>
            </div>
          )
        }}
        slides={slides}
        slideRenderFn={SnipsterSliderItem}
      />
    )
  }
}

SnipstersCarousel.propTypes = {
  extraClass: PropTypes.string,
  slides: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      imageUrl: PropTypes.string,
      content: PropTypes.oneOfType([PropTypes.node, PropTypes.string])
    }).isRequired
  ).isRequired
}

function mapStateToProps ({ browser }) {
  return {
    greaterThanSm: browser.greaterThan.sm
  }
}

export default connect(mapStateToProps)(SnipstersCarousel)



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/SnipstersCarousel.js